export const DEFAULT_FADE_DURATION = 250;
export const DEFAULT_SUPPORT_EMAIL = 'hello@trydaylight.com';
